export const projectQueryKeys = {
  all: ["PROJECT_DETAIL"],
  getProjectList: (options?: object) => [
    ...projectQueryKeys.all,
    "PROJECT_LIST",
    { options },
  ],
  getUserProjectList: (options?: object) => [
    ...projectQueryKeys.all,
    "USER_PROJECT_LIST",
    { options },
  ],
  getProjectDetail: (options?: object) => [
    ...projectQueryKeys.all,
    { options },
  ],
  getProjectSchedule: (options?: object) => [
    ...projectQueryKeys.all,
    "SCHEDULE",
    { options },
  ],
  getProjectStaticEventList: (options?: object) => [
    ...projectQueryKeys.all,
    "STATIC_EVENT_LIST",
    { options },
  ],
  getProjectEventList: (options?: object) => [
    ...projectQueryKeys.all,
    "EVENT_LIST",
    { options },
  ],
  getProjectComments: (options?: object) => [
    ...projectQueryKeys.all,
    "COMMENTS",
    { options },
  ],
  getCommentReplies: (options?: object) => [
    ...projectQueryKeys.all,
    "COMMENTS_REPLIES",
    { options },
  ],
  getProjectUserList: (options?: object) => [
    ...projectQueryKeys.all,
    "USER_LIST",
    { options },
  ],
};
